import CryptoJS from "crypto-js";

const randomKey = () => {
  const randomString = Math.random().toString() + Date.now();
  return CryptoJS.SHA256(randomString).toString().substring(0, 16);
};
/**
 * Returns an object with id, access, and refresh tokens retrieved from session storage.
 * @function getTokensFromStorage
 * @returns {Object} An object containing idToken, accessToken, and refreshToken.
 */
export const getTokensFromStorage = () => ({
  accessToken: randomKey(),
  idToken: randomKey(),
  refreshToken: randomKey(),
  tokenExp: randomKey(),
});
export default getTokensFromStorage;
